const createRequestActions = action =>
  ['_FETCH', '_SUCCEED', '_FAILURE']
    .map(suffix => action + suffix)
    .reduce((acc, str) => ({ ...acc, [str]: str }), {});

export const actions = {
  ...createRequestActions('GET_CONTRIBUTORS_SCORES'),
  ...createRequestActions('GET_ORGANIZATION_SCORES'),
  ...createRequestActions('GET_METRICS'),
  ...createRequestActions('GET_METRIC_DEFINITIONS'),
  ...createRequestActions('GET_ACCOUNT'),
  ...createRequestActions('DELETE_ACCOUNT'),
  ...createRequestActions('GET_ACCOUNTS'),
  ...createRequestActions('UPDATE_ACCOUNT'),
  ...createRequestActions('DESTROY_ACCOUNT'),
  ...createRequestActions('SEND_ACCOUNT_INVITATION'),
  ...createRequestActions('GET_CONFIGURATION'),
  ...createRequestActions('GET_CONTRIBUTORS'),
  ...createRequestActions('GET_PROJECTS'),
  ...createRequestActions('UPDATE_PROJECT'),
  ...createRequestActions('GET_REPOSITORIES'),
  ...createRequestActions('CREATE_REPOSITORIES'),
  ...createRequestActions('UPDATE_REPOSITORY'),
  ...createRequestActions('DELETE_REPOSITORY'),
  ...createRequestActions('GET_SERVICES'),
  ...createRequestActions('CREATE_SERVICE'),
  ...createRequestActions('UPDATE_SERVICE'),
  ...createRequestActions('DELETE_SERVICE'),
  ...createRequestActions('GET_ISSUE_TYPES'),
  ...createRequestActions('GET_ORGANIZATION'),
  ...createRequestActions('CREATE_ORGANIZATION'),
  ...createRequestActions('GET_PRS'),
  ...createRequestActions('GET_ITERATIONS'),
  ...createRequestActions('GET_INVITATIONS'),
  ...createRequestActions('DESTROY_INVITATION'),
  ...createRequestActions('INVITATION_CHANGE_ACCOUNT_TYPE'),
  ...createRequestActions('GET_SENSOR_AUTHORIZATIONS'),
  ...createRequestActions('CREATE_SENSOR_AUTHORIZATION'),
  ...createRequestActions('GET_JIRA'),
  ...createRequestActions('GET_BOARDS'),
  ...createRequestActions('SET_DEFAULT_BOARD'),
  ...createRequestActions('GET_DEFAULT_BOARD'),
  ...createRequestActions('REINVITE_USER'),
  ...createRequestActions('GET_BRANCHES'),
  ...createRequestActions('GET_BRANCHES_V2'),
  ...createRequestActions('GET_BRANCHES_STATS'),
  ...createRequestActions('GET_BRANCHES_SNAPSHOTS'),
  ...createRequestActions('GET_BRANCHES_SNAPSHOTS_STATS'),
  ...createRequestActions('GET_RELEASES'),
  ...createRequestActions('GET_COMMIT_STATS'),
  ...createRequestActions('UPDATE_SENSOR_AUTHORIZATION'),
  ...createRequestActions('DELETE_SENSOR_AUTHORIZATION'),
  ...createRequestActions('GET_TEAMS'),
  ...createRequestActions('CREATE_TEAM'),
  ...createRequestActions('UPDATE_TEAM'),
  ...createRequestActions('DELETE_TEAM'),
  ...createRequestActions('UPDATE_TEAM_CONTRIBUTORS'),
  ...createRequestActions('UPDATE_JOB'),
  ...createRequestActions('GET_ALL_SETTINGS'),
  ...createRequestActions('UPDATE_SETTING'),
  SELECT_ITERATION_ID: 'SELECT_ITERATION_ID',
  SELECT_PERIOD_KEY: 'SELECT_PERIOD_KEY',
  TOGGLE_MODAL: 'TOGGLE_MODAL',
  DATE_SELECTION_CHANGED: 'DATE_SELECTION_CHANGED',
  TOGGLE_LOADER: 'TOGGLE_LOADER',
  TOGGLE_SNACKBAR: 'TOGGLE_SNACKBAR',
  ROUTE_CHANGED: 'ROUTE_CHANGED',
  SET_ITERATIONS: 'SET_ITERATIONS',
  RESET_PRS: 'RESET_PRS',
  SELECT_TEAM_ID: 'SELECT_TEAM_ID',
  SETTINGS_TYPE: 'SETTINGS_TYPE',
  SET_IS_PROCESSING_REPOS: 'SET_IS_PROCESSING_REPOS',
  SET_IS_BLURRED: 'SET_IS_BLURRED',
  SET_HAS_NO_DATA: 'SET_HAS_NO_DATA',
  SET_HAS_ITERATIONS: 'SET_HAS_ITERATIONS',
  CLEAR_BRANCHES_V2: 'CLEAR_BRANCHES_V2',
  TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
  SET_SELECTED_TEAM_CHANGED_FROM_TOPBAR:
    'SET_SELECTED_TEAM_CHANGED_FROM_TOPBAR',
  FORCE_SYSTEM_UPDATE_SETTING: 'FORCE_SYSTEM_UPDATE_SETTING'
};

const createActionCreator = actionName =>
  ['_SUCCEED', '_FAILURE', '_FETCH'].map(actionType => payload => ({
    type: actions[`${actionName}${actionType}`],
    payload
  }));

/* eslint-disable import/no-unused-modules */
// Action creators
export const [getCommitStatsSucceed, getCommitStatsFailure] =
  createActionCreator('GET_COMMIT_STATS');
export const [updateSensorAuthorizationSucceed] = createActionCreator(
  'UPDATE_SENSOR_AUTHORIZATION'
);
export const [updateJobStateSucceed] = createActionCreator('UPDATE_JOB');
export const [deleteSensorAuthorizationSucceed] = createActionCreator(
  'DELETE_SENSOR_AUTHORIZATION'
);
export const [getTeamsSucceed, getTeamsFailure] =
  createActionCreator('GET_TEAMS');
export const [createTeamSucceed, createTeamFailure] =
  createActionCreator('CREATE_TEAM');
export const [updateTeamSucceed, updateTeamFailure] =
  createActionCreator('UPDATE_TEAM');
export const [deleteTeamSucceed, deleteTeamFailure] =
  createActionCreator('DELETE_TEAM');
export const [updateTeamContributorsSucceed, updateTeamContributorsFailure] =
  createActionCreator('UPDATE_TEAM_CONTRIBUTORS');
export const [getProjectsSucceed, getProjectsFailure] =
  createActionCreator('GET_PROJECTS');
export const [updateProjectSucceed, updateProjectFailure] =
  createActionCreator('UPDATE_PROJECT');
/* eslint-enable import/no-unused-modules */
export * from './account.js';
export * from './configuration.js';
export * from './contributors.js';

export * from './prs.js';

export * from './modal.js';
export * from './organization.js';
export * from './repositories.js';
export * from './services.js';
export * from './sensor-authorizations.js';
export * from './ui-state.js';
export * from './show-loader.js';
export * from './boards';
export * from './iterations.js';
export * from './branches';
export * from './settings';
export * from './issue-types';
